import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import CreateBox from './../createbox';
import CONSTANT from './../../../../shared/constants/constant';
import MasterService from './../../../services/masterdata.service';
import Util from './../../../../shared/util/util';

export default {
  name: 'boxlisting',
  components: {
    VueElementLoading,
    BasicSelect,
    Pagination,
    CustomExpandableTable,
    CreateBox
  },
  props: [],
  data() {
    return {
      type: 'BOXTYPE_MASTER',
      showCreateBoxData: false,
      isLoading:false,
      boxtypeName: '',
      boxtypeNameSearch: '',
      totalCount: 0,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Product','Box Type', 'Box Type Description', 'Stacking Level',
      'Box Strength', 'Avg. Physical weight','Dimensions','Created By',
      'Created Date','Last Modified By','Last Modified Date','Status','Action'],
      tableItems: [],
      innerTableColumn: [],
      selectedBoxTypeObj: [],
      boxstrengthlist: [],
      stackinglevellist: [],
      boxtypeDetails:"",
      status:"",
      statusSearch:"",
      statuslist:[{
        value : "1",
        text : 'Active'
      },{
        value : "0",
        text : 'Inactive'
      }],
      statusitem:{value:'',text:''},
    }
  },
  computed: {},
  async mounted() {
    this.isLoading = true;
    Promise.all([this.getAllBoxStackingLevels(),
                 this.getAllBoxStrengths()]);
    this.isLoading = false;
    await this.getBoxTypesListing();
  },
  methods: {
    selectedStatus(statusitem){
      this.statusitem = statusitem;
      this.status = this.statusitem.value;
    },
    showBoxData() {
      this.selectedBoxTypeObj = [];
      this.showCreateBoxData = true;
    },
    callParent() {
        this.showCreateBoxData = false;
        this.selectedBoxTypeObj = [];
        this.currentPage = 1;
        this.offset = 0;
        this.getBoxTypesListing("");
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getBoxTypesListing();
    },
    getCustomTableEvent(event) {
      if(event.actionType=="active"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       });
     }else if(event.actionType=="inactive"){
        this.$confirm("Are you sure to make Active/Inactive?","","question").then(() => {
        this.activeAction(event);
       }).catch((err)=>{
         console.log(err)
       })
      }
      if(event.actionType=="edit"){
        let selectedBoxTypeObj  = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedBoxTypeObj = selectedBoxTypeObj[0];
        this.showCreateBoxData = true;
      }else if(event.actionType=="view"){
        this.getBoxTypeDetails(event.id);
      }
    },
    async getBoxTypeDetails(boxtypeid){
      try {
        let InputPayload = {
          boxtypeid: boxtypeid
        }
        this.isLoading = true;
        let response = await MasterService.getBoxTypeDetails(InputPayload);
        this.boxtypeDetails = response.data.data;
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        console.log(err);
      }
    },
    searchBoxTypes(){
      this.currentPage = 1;
      this.offset = 0;
      this.boxtypeNameSearch = this.boxtypeName;
      this.statusSearch = this.status;
      if((this.boxtypeNameSearch!="") || (this.statusSearch!="")){
      this.getBoxTypesListing();
      }
    },
    resetBoxTypes(){
      this.currentPage = 1;
      this.offset = 0;
      this.boxtypeName= "";
      this.boxtypeNameSearch= "";
      this.status= "";
      this.statusSearch= "";
      this.statusitem = {};
      this.getBoxTypesListing();
    },
    async getAllBoxStackingLevels(){
      try {
        let InputPayload = {};
        let result = await MasterService.getAllBoxStackingLevels(InputPayload);
        let stackinglevellist = result.data.data;
        for (var i = 0; i < stackinglevellist.length; i++) {
          this.stackinglevellist.push({
            'value': stackinglevellist[i].variantvalue,
            'text': stackinglevellist[i].variantvalue
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    async getAllBoxStrengths(){
      try {
        let InputPayload = {};
        let result = await MasterService.getAllBoxStrengths(InputPayload);
        let boxstrengthlist = result.data.data;
        for (var i = 0; i < boxstrengthlist.length; i++) {
          this.boxstrengthlist.push({
            'value': boxstrengthlist[i].variantvalue,
            'text': boxstrengthlist[i].variantvalue
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    getStackingLevelName(stackingid) {
      for (var i = 0; i < this.stackinglevellist.length; i++) {
        if (this.stackinglevellist[i].value == stackingid) {
          return this.stackinglevellist[i].text;
        }
      }
    },
    getBoxStrenghtName(boxstrengthid) {
      for (var i = 0; i < this.boxstrengthlist.length; i++) {
        if (this.boxstrengthlist[i].value == boxstrengthid) {
          return this.boxstrengthlist[i].text;
        }
      }
    },
    async getBoxTypesListing(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.boxtypeNameSearch!=""){
          inputPayload.boxtypename = this.boxtypeNameSearch;
        }
        if(this.statusSearch!=""){
          inputPayload.status = this.statusSearch;
        }
        let allResolved = await Promise.all([MasterService.getBoxTypeListing(inputPayload)])
        let result = allResolved[0]
        this.tableArr = result.data.data.rows;
        this.totalCount = result.data.data.count;
        if(this.totalCount>0){        
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.id,
              'Product':el.product,
              'Box Type':el.boxtype,
              'Box Type Description': el.boxtypedescription,
              'Stacking Level': el.stackinglevel,
              'Box Strength': el.boxstrength,
              'Avg. Physical weight':el.averagephysicalweight,
              'Dimensions':(JSON.stringify(el.dimensions)).replace(/[{}""]/g, ""),
              'Created By':el.createdby,
              'Created Date':Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'Status': el.status,
              'Action': 'Need To Check1'
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async activeAction(data){
      try {
        this.isLoading = true;
        var item = this.tableArr.find(item => item.id === data.id);
        var isactivestatus = item.status == 0 ? 1 : 0
        let inputPayload = {
          "id": data.id,
          "type": this.type,
          "status": isactivestatus
        }
        let result = await MasterService.changeStatus(inputPayload)
        if(result.data.code == 200){
          if(result.data.data[0].status == 0){
          this.$alert("Box Type Activated Successfully!!", this.boxtype, "success");
        }else{
          this.$alert("Box Type Inactivated Successfully!!", this.boxtype, "success");
         }
          this.getBoxTypesListing();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/BoxType/boxlisting/boxlisting.component.js